// constants/colors.js
export const colors = {
  white: "#ffffff",
  darkWhite:"#F7FAF8",
  darkBlack: "#000000",
  darkGray: "#4B4B4B",
  midGray: "#C4C4C4",
  lightGray: "#EFEFF0",
  green: "#31A05F",
  darkGreen: "#279450",
  paleGreen: "#E9F7EF",
  mintGreen: "#C6EFD8",
  darkOlive: "#2E7D32",
  lightMint: "#E8F5E9",
  orange: "#EF9920",
  lightGreen: "#D3EDDF",
  red: "#f44336",
  lightRed: "#ffebee",
  deleteBg: "#ffd9d9ff",
  editBg: "#e6ffd9ff",
  deepGreen: "#1B5E20",
  limeGreen: "#66BB6A",
  softMint: "#F5F9F7",
  hoverMint: "#E8F5EE",
  borderGray: "rgba(0,0,0,0.08)",
  navbarGlass: "rgba(255, 255, 255, 0.8)",
  greenGradient: "linear-gradient(135deg, #2E7D32 0%, #4BBE6A 100%)",
  greenGradientAlt: "linear-gradient(90deg, #1B5E20 0%, #66BB6A 100%)",

  // WhatsApp specific colors
  whatsappGreen: '#279450',
  whatsappGreenDark: '#075E54',
  whatsappChatBg: '#e5ddd5', 

};

export default colors;